import { axiosPrivate } from '@/shared/api/axios'
import { API } from '@/shared/constants/api'
import type { IAgencyLookup } from '../hooks/use-agencies-query'

/** Lookup para selectors externos; el CRUD admin vive en agencies-admin.service.ts. */
export const agenciesService = {
  getLookup: () => axiosPrivate.get<IAgencyLookup[]>(API.agencies.lookup).then((r) => r.data)
}
